export const GET_NEW_TAX_REVENUES_SANITARY =
  'NEW_TAX_REVENUE_SANITARY/get_new_tax_revenues';
export const GET_SINGLE_NEW_TAX_REVENUES_SANITARY =
  'NEW_TAX_REVENUE_SANITARY/get_single_new_tax_revenues';
export const UPDATE_NEW_TAX_REVENUES_SANITARY =
  'NEW_TAX_REVENUE_SANITARY/update_new_tax_revenues';
export const CREATE_NEW_TAX_REVENUES_SANITARY =
  'NEW_TAX_REVENUE_SANITARY/create_new_tax_revenues';
export const REMOVE_NEW_TAX_REVENUES_SANITARY =
  'NEW_TAX_REVENUE_SANITARY/remove_new_tax_revenues';
export const GET_NEW_TAX_REVENUES_TYPE_SANITARY =
  'NEW_TAX_REVENUE_SANITARY/get_new_tax_revenues_type';

export const GET_CALCULATIONS_SANITARY =
  'CALCULATIONS_SANITARY/get_calculations';
export const UPDATE_CALCULATIONS_SANITARY =
  'CALCULATIONS_SANITARY/update_calculations';
export const CREATE_CALCULATIONS_SANITARY =
  'CALCULATIONS_SANITARY/create_calculations';
export const REMOVE_CALCULATIONS_SANITARY =
  'CALCULATIONS_SANITARY/remove_calculations';
export const GET_CALCULATIONS_TYPE_SANITARY =
  'CALCULATIONS_SANITARY/get_calculations_type';

export const GET_DETAILS_SANITARY = 'DETAILS_SANITARY/get_details';
export const UPDATE_DETAILS_SANITARY = 'DETAILS_SANITARY/update_details';
export const CREATE_DETAILS_SANITARY = 'DETAILS_SANITARY/create_details';
export const REMOVE_DETAILS_SANITARY = 'DETAILS_SANITARY/remove_details';

export const FORM_DATA = {
  code: '',
  description: '',
  tax_revenue_type_id: '',
};

export const CALCULATIONS_FORM_DATA = {
  multiplier: '',
  label: '',
  for_new: '',
  for_renewal: '',
  tax_revenue_calculation_type_id: '',
};

export const FORM_DATA_DETAILS = {
  amount: '',
  for_every: '',
  for_every_amount: '',
  from: '',
  to: '',
  rate: '',
  label: '',
  multiplier: '',
  option: '',
  in_excess_of: '',
};

export const multiplierOption = [
  { label: 'Area', value: 'area' },
  { label: 'No. of Employees', value: 'no_of_employees' },
  { label: 'No. of Male Employees', value: 'no_of_male_employees' },
  { label: 'No. of Female Employees', value: 'no_of_female_employees' },
  { label: 'No. of Employees Residing in Manila', value: 'no_of_employees_residing_manila' },
  { label: 'No. of Vans', value: 'no_of_van' },
  { label: 'No. of Trucks', value: 'no_of_truck' },
  { label: 'No. of Motorcycles', value: 'no_of_motorcycles' },
  { label: 'No. of Vehicles', value: 'no_of_vehicles' },
  { label: 'Location Owned', value: 'location_owned' },
];